export default function(x) {
  return x === null ? NaN : +x;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-array/src/number.js
// module id = 21
// module chunks = 0